import { Building } from './Building';
export class Ice extends Building {
  readonly type = 'ice' as const;
}
